import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppLayout } from "./components/layout/AppLayout";
import Dashboard from "./pages/Dashboard";
// import Blog from "./pages/Blog";
// import Resources from "./pages/Resources";
import Leads from "./pages/Leads";
import MediaLibrary from "./pages/MediaLibrary";
// import UsersRoles from "./pages/UsersRoles";
// import WebinarsEvents from "./pages/WebinarsEvents";
// import SEO from "./pages/SEO";
// import GlobalSettings from "./pages/GlobalSettings";
// import ThemeSettings from "./pages/ThemeSettings";
import NotFound from "./pages/NotFound";

// Pages module
import { PagesList } from "./pages/pages/PagesList";
import { PageForm } from "./pages/pages/PageForm";

import { PageView } from "./pages/pages/PageView";
import { HomePageForm } from "./pages/pages/HomePageForm";

// Blog module
// import { BlogList } from "./pages/blog/BlogList";
// import { BlogForm } from "./pages/blog/BlogForm";

// Resources module
// import { ResourcesList } from "./pages/resources/ResourcesList";
// import { ResourceForm } from "./pages/resources/ResourceForm";

// Webinars module
// import { WebinarsList } from "./pages/webinars/WebinarsList";
// import { WebinarForm } from "./pages/webinars/WebinarForm";

// Solutions module
import { SolutionsList } from "./pages/solutions/SolutionsList";
import { SolutionForm } from "./pages/solutions/SolutionForm";

// Products module
import { ProductsList } from "./pages/products/ProductsList";
import { ProductForm } from "./pages/products/ProductForm";

// Services module
import { ServicesList } from "./pages/services/ServicesList";
import { ServiceForm } from "./pages/services/ServiceForm";

// Industries module
import { IndustriesList } from "./pages/industries/IndustriesList";
import { IndustryForm } from "./pages/industries/IndustryForm";
import Vacancies from "./pages/Vacancies";
import Careers from "./pages/Careers";
import Blogs from "./pages/Blogs";
import CaseStudies from "./pages/CaseStudies";
import Newsletter from "./pages/Newsletter";
import ProfileSettings from "./pages/ProfileSettings";
import Login from "./pages/Login";
import { HomeCMS } from "./pages/pages/HomeCMS";
import { SolutionsCMS } from "./pages/pages/SolutionCMS";
import { ProductsCMS } from "./pages/pages/ProductCMS";
import { ServicesCMS } from "./pages/pages/ServiceCMS";
import { IndustriesCMS } from "./pages/pages/IndustriesCMS";
import { ResourcesCMS } from "./pages/pages/ResourcesCMS";
import { AboutCMS } from "./pages/pages/AboutCMS";
import { CareersCMS } from "./pages/pages/CareerCMS";
import { MethodologyCMS } from "./pages/pages/MethodologyCMS";
import { PartnersCMS } from "./pages/pages/PartnersCMS"; 
import { ChangePartnerCMS } from "./pages/pages/ChangePartnerCMS";
import { FAQCMS } from "./pages/pages/FAQCMS";
import { GuidesCMS } from "./pages/pages/GuidesCMS";
import { ContactCMS } from "./pages/pages/ContactCMS";
import  LicensingCalculator  from "./pages/pages/LicensingCalculator";
import  EstimatorConfig  from "./pages/pages/EstimatorConfig";
import { Footer } from "./pages/pages/templates/Footer";
import Staff from "./pages/Staff";
import StaffForm from "./pages/StaffForm";
import WebinarEvents from "./pages/WebinarEvents";
import WebinarEventForm from "./pages/WebinarEventForm";
import { FooterCMS } from "./pages/pages/FooterCMS";
import { PrivacyCMS } from "./pages/pages/PrivacyCMS";
import { TermsCMS } from "./pages/pages/TermsCMS";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Pages */}
            <Route path="/pages" element={<PagesList />} />
            <Route path="/pages/home" element={<HomePageForm />} />
            <Route path="/pages/new" element={<PageForm mode="create" />} />
            <Route path="/pages/:id" element={<PageView />} />
            <Route path="/pages/:id/edit" element={<PageForm mode="edit" />} />
            <Route path="/homeCMS" element={<HomeCMS />} />
            <Route path="/solutionCMS" element={<SolutionsCMS />} />
            <Route path="/productCMS" element={<ProductsCMS />} />
            <Route path="/serviceCMS" element={<ServicesCMS />} />
            <Route path="/industriesCMS" element={<IndustriesCMS />} />
            <Route path="/resourcesCMS" element={<ResourcesCMS />} />
            <Route path ="aboutCMS" element={<AboutCMS />} />
            <Route path="/careersCMS" element={<CareersCMS />} />
            <Route path="/methodologyCMS" element={<MethodologyCMS />} />
            <Route path="/partnersCMS" element={<PartnersCMS />} />
            <Route path="/changePartnersCMS" element={<ChangePartnerCMS />} /> 
            <Route path="/faqCMS" element={<FAQCMS />} />
            <Route path="/guidesCMS" element={<GuidesCMS />} />
            <Route path="/contactCMS" element={<ContactCMS />} />
            <Route path="/footerCMS" element={<FooterCMS />} />
            <Route path="/privacyCMS" element={<PrivacyCMS />} />
            <Route path="/termsCMS" element={<TermsCMS />} />
            <Route path="/licensing_calculator" element={<LicensingCalculator />} />
            <Route path="/estimator_config" element={<EstimatorConfig />} />
            <Route path="/profile-settings" element={<ProfileSettings />} />
            <Route path="/webinars" element={<WebinarEvents />} />
            <Route path="/webinars/add" element={<WebinarEventForm />} />
            <Route path="/webinars/edit/:id" element={<WebinarEventForm />} />

            {/* Solutions */}
            <Route path="/solutions" element={<SolutionsList />} />
            <Route
              path="/solutions/new"
              element={<SolutionForm mode="create" />}
            />
            <Route
              path="/solutions/:id/edit"
              element={<SolutionForm mode="edit" />}
            />

            {/* Products */}
            <Route path="/products" element={<ProductsList />} />
            <Route
              path="/products/new"
              element={<ProductForm mode="create" />}
            />
            <Route
              path="/products/:id/edit"
              element={<ProductForm mode="edit" />}
            />

            {/* Services */}
            <Route path="/services" element={<ServicesList />} />
            <Route
              path="/services/new"
              element={<ServiceForm mode="create" />}
            />
            <Route
              path="/services/:id/edit"
              element={<ServiceForm mode="edit" />}
            />

            {/* Industries */}
            <Route path="/industries" element={<IndustriesList />} />
            <Route path="/vacancies" element={<Vacancies />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/blog" element={<Blogs />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route
              path="/industries/new"
              element={<IndustryForm mode="create" />}
            />
            <Route
              path="/industries/:id/edit"
              element={<IndustryForm mode="edit" />}
            />

            {/* Case Studies */}
            {/* <Route path="/case-studies" element={<CaseStudiesList />} />
            <Route
              path="/case-studies/new"
              element={<CaseStudyForm mode="create" />}
            />
            <Route
              path="/case-studies/:id/edit"
              element={<CaseStudyForm mode="edit" />}
            /> */}

            {/* Resources */}
            {/* <Route path="/resources" element={<ResourcesList />} />
            <Route
              path="/resources/new"
              element={<ResourceForm mode="create" />}
            />
            <Route
              path="/resources/:id/edit"
              element={<ResourceForm mode="edit" />}
            /> */}

            {/* Webinars */}
            {/* <Route path="/webinars" element={<WebinarsList />} />
            <Route
              path="/webinars/new"
              element={<WebinarForm mode="create" />}
            />
            <Route
              path="/webinars/:id/edit"
              element={<WebinarForm mode="edit" />}
            /> */}

            {/* Blog */}
            {/* <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/new" element={<BlogForm mode="create" />} />
            <Route path="/blog/:id/edit" element={<BlogForm mode="edit" />} /> */}

            {/* Other modules */}
            <Route path="/media" element={<MediaLibrary />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/footer" element={<Footer />} />
            {/* <Route path="/seo" element={<SEO />} />
            <Route path="/global-settings" element={<GlobalSettings />} />
            <Route path="/users" element={<UsersRoles />} />
            <Route path="/theme" element={<ThemeSettings />} /> */}

            <Route path="/staff" element={<Staff />} />
            <Route path="/staff/add" element={<StaffForm />} />
            <Route path="/staff/edit/:id" element={<StaffForm />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
